<template>
  <v-row>
    <v-col md="12">
      <v-card>
        <vue-card-title
          :title="selectedStage"
          :subtitle="
            'Refer to the following information on common sales sub stages.'
          "
          :icon="$getIcon('mdiClipboardTextOutline')"
        >
          <template slot="actions">
            <v-btn
              class="text-capitalize my-0 mr-2"
              small
              @click="salesSubStageForm = true"
            >
              Create Common Sub Stage of - {{ selectedStage }}
            </v-btn>
            <v-btn icon small @click="showSubStages = !showSubStages">
              <v-icon color="grey" v-text="$getIcon('mdiClose')"> </v-icon>
            </v-btn>
          </template>
        </vue-card-title>
        <v-card-title> </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col md="8" offset-md="2">
              Sub Stages of {{ selectedStage }} (Common)
              <v-divider class="my-2"></v-divider>
              <v-data-table
                :items="salesSubStages"
                class="elevation-1"
                hide-default-header
                hide-default-footer
                itemsPerPage="20"
              >
                <template v-slot:item="props">
                  <tr>
                    <td>
                      <small>{{ props.item.order }}.</small>
                      {{ props.item.name }}
                      <small
                        v-if="props.item.is_process"
                        class="d-block grey--text mx-2"
                        >Process</small
                      >
                      <small v-else class="d-block grey--text mx-2"
                        >Communication</small
                      >
                    </td>
                    <td>
                      <v-icon
                        class="caption btn-tny pa-1"
                        @click="
                          (selectedSalesSubStageData = props.item) &&
                            (salesSubStageForm = true)
                        "
                        v-text="$getIcon('mdiPencil')"
                      ></v-icon>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col md="12">
      <!-- Sales Sub Stage Form -->
      <v-bottom-sheet v-model="salesSubStageForm" scrollable>
        <v-card tile>
          <vue-card-title
            :display-card.sync="salesSubStageForm"
            :title="cardTitle"
            :subtitle="
              'Fill up the following form to action on common sales sub stage.'
            "
            :icon="$getIcon('mdiFileDocumentEdit')"
            closable
            @close="salesSubStageForm = false"
          >
          </vue-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <sales-sub-stage-form
              v-if="selectedSalesSubStageData && salesSubStageForm"
              :action-data="selectedSalesSubStageData"
              :selected-stage="selectedStage"
              :selected-stage-id="selectedStageId"
              @salesSubStageResponse="formSuccess"
            >
            </sales-sub-stage-form>
          </v-card-text>
        </v-card>
      </v-bottom-sheet>
      <!-- / Sales Sub Stage Form -->
    </v-col>
  </v-row>
</template>

<script>
import SalesSubStageForm from "@/components/crm/configuration/sales_stage/forms/SalesSubStageForm";

export default {
  components: { SalesSubStageForm },
  props: {
    selectedStage: {
      type: String,
      required: true
    },
    selectedStageId: {
      type: Number,
      required: true
    },
    salesStageForm: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      fetched: false,
      showSubStages: true,
      salesSubStages: [],
      // form
      salesSubStageForm: false,
      cardTitle: "",
      selectedSalesSubStageData: {}
    };
  },
  watch: {
    salesStageForm(val) {
      this.updateSalesStage = val;
    },
    showSubStages(val) {
      this.$emit("update:showSubStages", val);
    },
    selectedStageId(oldVal, newVal) {
      if (oldVal !== newVal) {
        this.fetchSalesSubStages();
      }
    },
    salesSubStageForm(newVal) {
      if (Object.keys(this.selectedSalesSubStageData).length > 0 && newVal) {
        this.cardTitle = "Update Sales Sub Stage";
      } else {
        this.selectedSalesSubStageData = {};
        this.cardTitle = "Create Sales Sub Stage";
      }
    }
  },
  mounted() {
    this.fetchSalesSubStages();
  },
  methods: {
    fetchSalesSubStages() {
      const salesSubStagesAPI = `/api/v1/crm/sales-sub-stages/?organization__slug=${this.$route.params.orgSlug}&&service_filter=true`;
      const params = { sales_stage__id: this.selectedStageId, fetch_all: true };
      this.fetched = false;
      this.$axios.$get(salesSubStagesAPI, { params }).then(response => {
        this.salesSubStages = response;
        this.fetched = true;
      });
    },
    formSuccess() {
      this.salesSubStageForm = false;
      this.fetchSalesSubStages();
    }
  }
};
</script>
